import { ChartColor, Scriptable } from 'chart.js';


// colocando as cores do gráfico
export type themeGraph =
  | 'delay'
  | 'alocation'
  | 'status'
  | 'overallocation'
  | 'planning'
  | 'activityexpected';

export default function selectTheme(
  theme?: themeGraph,
): ChartColor | ChartColor[] | Scriptable<ChartColor> {
  const delayTheme = [
    '#b22222',
    'rgba(0, 0, 0, 0.15)',
    '#ff0000',
    'rgba(0, 0, 0, 0.06)',
  ];

  const alocationTheme = ['#090979', '#b2dfee94', '#00BFFF', '#b2dfee94'];
  const overallocationTheme = ['#ff3547'];
  const planningTheme = ['#00BFFF'];

  // arrumar cor dos atrasados e pendentes
  const statusActTheme = ['#1A365D', '#ed8946', '#A0AEC0'];

  /* if (typeof theme !== 'string' && theme !== undefined) {
    throw new Error();
  } */

 const ActExpectedTheme = ['#09791cff', '#d3f75494', '#090979','#b2dfee94']

  switch (theme) {
    case 'delay':
      return delayTheme;

    case 'alocation':
      return alocationTheme;

    case 'status':
      return statusActTheme;

    case 'overallocation':
      return overallocationTheme;

    case 'activityexpected':
      return ActExpectedTheme;

    default:
      return alocationTheme;
  }
}

export function selectTwoColorTheme(theme?: themeGraph): string[] {
  const delayTheme = ['#b22222', '#ff0000'];

  const alocationTheme = ['#090979', '#00BFFF'];

  switch (theme) {
    case 'delay':
      return delayTheme;

    case 'alocation':
      return alocationTheme;

    /* case 'overallocation':
      return overallocationTheme; */

    /* case 'planning':
      return planningTheme; */

    default:
      return alocationTheme;
  }
}
